import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_modifier_price_display_style.js";
//#region src/menu_modifier_price_display_style_helper.ts
var menu_modifier_price_display_style_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(modifierPriceDisplayStyle) {
	switch (modifierPriceDisplayStyle) {
		case "show-price-in-header": return "Show price in the header";
		case "show-price-on-all-mods": return "Show price on all modifiers";
	}
}
//#endregion
export { menu_modifier_price_display_style_helper_exports, name };

//# sourceMappingURL=menu_modifier_price_display_style_helper.js.map